import React, { Component } from 'react';
import axios from '../axios';
import Alert from 'react-s-alert'
import FormDropdown from '../components/FormDropdown'
import { connect } from 'react-redux'
import fp from 'lodash/fp'
import { penerima_item } from '../constants/itemAnggaran'
// import DatePicker from 'react-datepicker'
// import moment from 'moment'
import { updateCekKartuState, resetCekKartuState } from '../actions/formCekKartuAction'

class FormCekKartu extends Component {
    constructor(props) {
        super(props)

        this.handleChange                       = this.handleChange.bind(this);
        this.handleSubmit                       = this.handleSubmit.bind(this);
        this.handleChangeDropdownAnggaran       = this.handleChangeDropdownAnggaran.bind(this);
        this.handleCekKartuClick                = this.handleCekKartuClick.bind(this);
        this.handleChangeAnggotaKeluarga        = this.handleChangeAnggotaKeluarga.bind(this);
        this.handleResetFormClick               = this.handleResetFormClick.bind(this);
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.type === 'checkbox' ? target.checked : target.value;
        const name   = target.name;

        if (name === "kode_kartu") {
            if (this.props.cekKartuState.item_id !== 0) {
                this.props.updateItemsState({ [name]: value })
            }
            else {
                Alert.error("Silahkan pilih item bantuan terlebih dahulu !")
            }
        }
        else {
            this.props.updateItemsState({ [name]: value })
        }        
    }

    handleSubmit() {

        this.props.updateItemsState({isButtonLoading: true})

        setTimeout(() => {
            this.props.updateItemsState({isButtonLoading: false})
        }, 2000)

        // axios({
        //     method: 'post',
        //     url: '/tahun_anggaran/saveTahun',
        //     data: qs.stringify(this.props.cekKartuState)
        // })
        //     .then(response => {
        //
        //         const result = response.data;
        //
        //         if (result.status !== 1) {
        //
        //             result.msg.map((item) => {
        //                 Alert.error(item)
        //
        //                 return true;
        //             })
        //
        //             this.props.updateItemsState({isButtonLoading: false})
        //         }
        //         else {
        //             Alert.success(result.msg)
        //             this.props.history.replace("/tahun_anggaran");
        //         }
        //
        //         return true;
        //     })
        //     .catch(error => {
        //         console.log(error)
        //         this.props.updateItemsState({isButtonLoading: false})
        //     })

    }

    handleClick() {

        this.props.updateItemsState({buttonIsLoading: true})

        axios({
            method: "get",
            url: "/kartu/getKartuByCode?kode_kartu=" + this.props.cekKartuState.kode_kartu
        })
            .then(response => {

                const result = response.data

                if ( ! fp.isEmpty(result.infoKartu)) {

                    this.props.updateItemsState({ isKartuValid: true })                    
                }
                else {

                    Alert.error("Kartu tidak valid..");
                    this.props.updateItemsState({isKartuValid: false})
                }
            })
            .catch(error => {
                
                console.log(error)
                Alert.error("Gagal terhubung ke server!")
            })
    }

    handleChangeDropdownAnggaran(event) {
        
        const value  = event.target.value;
        
        if (value !== "") {
            
            this.props.updateItemsState({
                item_id                 : this.props.cekKartuState.dataAnggaran[value].item_id,
                valueDropdownAnggaran   : value,
                penerima_item           : this.props.cekKartuState.dataAnggaran[value].penerima_item,
                tipe_item               : this.props.cekKartuState.dataAnggaran[value].tipe_item,
                group_pendidikan        : this.props.cekKartuState.dataAnggaran[value].group_pendidikan,
            })
        }        
    }

    handleCekKartuClick() {

        this.props.updateItemsState({buttonIsLoading: true})

        axios({
            method: "get",
            url: "/kartu/getKartuByCode?kode_kartu=" + this.props.cekKartuState.kode_kartu
        })
            .then(response => {

                const result = response.data

                if ( ! fp.isEmpty(result.infoKartu)) {
                    
                    const dropdownAnggota = result.anggotaKartu.map((item, index) => ({
                        key: index,
                        value: item.nama_anggota
                    }))

                    this.props.updateItemsState({
                        dataKartu: {
                            kartu_id     : result.infoKartu.kartu_id,
                            kode_kartu   : result.infoKartu.kartu_kode,
                            expired_date : result.infoKartu.kartu_expired,
                            no_kk        : result.infoKartu.no_kk,
                            kecamatan    : result.infoKartu.city_name,
                        },
                        dataAnggota         : result.anggotaKartu,
                        dataDropdownAnggota : dropdownAnggota,
                        buttonIsLoading     : false,
                        isKartuValid        : true
                    })

                    if (this.props.cekKartuState.penerima_item === "perkk") {

                        this.loadCekKartuSaldo()
                    }
                }
                else {

                    Alert.error("Kartu tidak valid..");
                    this.props.updateItemsState({dataKartu: null, dataAnggota: null, buttonIsLoading: false, isKartuValid: false})
                }
            })
            .catch(error => {
                console.log(error)
                Alert.error("Gagal terhubung ke server!")
            })
    }

    handleChangeAnggotaKeluarga(event) {

        const value = event.target.value;

        if (value !== "") {            

            const detailAnggota = this.props.cekKartuState.dataAnggota[value]
                            
            this.props.updateItemsState({
                id_kartu_anggota        : detailAnggota.id_kartu_anggota,
                pendidikan_nisn         : detailAnggota.pendidikan_nisn === null ? "" : detailAnggota.pendidikan_nisn,
                kesehatan_no_jamkesmas  : detailAnggota.kesehatan_no_jamkesmas === null ? "" : detailAnggota.kesehatan_no_jamkesmas,
                valueDropdownAnggota    : value
            })            
        }        
    }

    handleResetFormClick() {        

        this.props.resetCekKartuState()
        this.loadDataAnggaran()
    }

    /*
     * Mengecek apakah kombinasi id_kartu_anggota + kartu_id + item_id 
     * Atau kombinasi kartu_id + item_id ada di tabel kartu_saldo
     */
    loadCekKartuSaldo() {

        const kartu_id = this.props.cekKartuState.isKartuValid ? this.props.cekKartuState.dataKartu.kartu_id : ""

        axios.get("/kartu/cekKartuSaldo?kartu_id=" + kartu_id + "&item_id=" + this.props.cekKartuState.item_id +"&id_kartu_anggota=" + this.props.cekKartuState.id_kartu_anggota)
            .then(response => {
                this.props.updateItemsState({
                    sudahTerdaftar: response.data.status_terdaftar, 
                    id_kartu_saldo: response.data.id_kartu_saldo
                })
            })
            .catch(error => {
                console.log(error)
                Alert.error("Gagal terhubung ke server!")
            })
    }

    loadDataAnggaran() {

        axios.get('/anggaran/getAllItemAnggaran?tipe_item=kesehatan')
            .then(response => {
                const dataDropdown = response.data.map((item, index) => {
                    return {key:index, value: item.nama_item}
                })

                return {
                    dataDropdown: dataDropdown,
                    dataFull    : response.data
                }
            })
            .then(items => {
                
                this.props.updateItemsState({
                    dataAnggaran        : items.dataFull, 
                    dataDropdownAnggaran: items.dataDropdown
                })
            })
            .catch((error) => {
                console.log(error)
                Alert.error("Gagal terhubung ke server!")
            });
    }    

    componentDidMount() {
        
        this.loadDataAnggaran()
    }

    componentDidUpdate(prevProps, prevState) {
    
        if (this.props.cekKartuState.id_kartu_anggota !== prevProps.cekKartuState.id_kartu_anggota) {
            this.loadCekKartuSaldo()
        }
    }
    
    render() {

        const textPenerimaItem = penerima_item.filter((item) => {            
            return item.key === this.props.cekKartuState.penerima_item
        })

        return (
            <div>
                <div className="card">
                    <div className="card-header">
                        Cek Kartu
                        <button className="btn btn-sm btn-danger pull-right" style={{marginTop: "2px"}} onClick={this.handleResetFormClick}>
                           <i className="fa fa-refresh"></i> Reset Form
                        </button>
                    </div>
                    <div className="card-block">
                        <div className="form-group">
                            <label className="form-control-label">Item Bantuan</label>
                             <FormDropdown
                                name="item_id"
                                onChange={this.handleChangeDropdownAnggaran}
                                value={this.props.cekKartuState.valueDropdownAnggaran}
                                disabled={this.props.cekKartuState.isKartuValid}
                                items={this.props.cekKartuState.dataDropdownAnggaran}
                                placeholder="- Pilih Item Bantuan:" /> 
                        </div>
                        <div className="form-group row">
                            <div className="col-md-12">
                                <label className="form-control-label">Input No Kartu</label>
                                <div className="input-group">
                                    <input
                                        name="kode_kartu"
                                        type="text"
                                        className="form-control"
                                        placeholder="Masukan nomor kartu"
                                        onChange={this.handleChange}
                                        value={this.props.cekKartuState.kode_kartu}
                                        disabled={this.props.cekKartuState.isKartuValid}
                                    />
                                    <span className="input-group-btn">
                                        <button 
                                            type="button" 
                                            className="btn btn-primary"
                                            onClick={this.handleCekKartuClick}
                                            disabled={this.props.cekKartuState.buttonIsLoading || this.props.cekKartuState.isKartuValid}
                                        >
                                            {
                                                this.props.cekKartuState.buttonIsLoading ? "Loading ..." : 
                                                    this.props.cekKartuState.isKartuValid ? <span><i className='fa fa-check'></i> Kartu Valid</span> : "Cek Kartu"
                                            }
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="form-group" style={{display: this.props.cekKartuState.penerima_item === "" ? "none" : "block"}}>
                            <label className="form-control-label">Jenis Penerima Bantuan</label>
                            <input
                                name="penerima_item"
                                type="text"
                                disabled={true}
                                className="form-control"
                                value={textPenerimaItem.length !== 0 && textPenerimaItem[0].value}
                            />
                        </div>
                        <div 
                            className="form-group" 
                            style={{display: this.props.cekKartuState.penerima_item === "perorang" && this.props.cekKartuState.isKartuValid ? "block" : "none"}
                            }>
                        
                            <label className="form-control-label">Anggota Keluarga </label>
                            <FormDropdown 
                                name="id_kartu_anggota"
                                onChange={this.handleChangeAnggotaKeluarga}
                                items={this.props.cekKartuState.dataDropdownAnggota}
                                value={this.props.cekKartuState.valueDropdownAnggota}
                            /> 
                        </div>                        
                        <div className="form-group" style={{display: this.props.cekKartuState.tipe_item === "kesehatan" && this.props.cekKartuState.isKartuValid ? "block" : "none"}}>
                            <label className="form-control-label">Nomor Jamkesmas</label>
                            <input
                                name="kesehatan_no_jamkesmas"
                                type="text"
                                onChange={this.handleChange}
                                className="form-control"
                                value={this.props.cekKartuState.kesehatan_no_jamkesmas}
                                disabled={true}
                            />
                        </div>
                        {
                            this.props.cekKartuState.sudahTerdaftar ? 
                                <div className="form-group">
                                    <label className="form-control-label">Status Terdaftar</label>
                                    <div className="form-control bg-success">
                                        <i className="fa fa-check"></i> Sudah Terdaftar
                                    </div>
                                </div> : 
                                this.props.cekKartuState.isKartuValid ? 
                                    <div className="form-group">
                                        <label className="form-control-label">Status Terdaftar</label>
                                        <div className="form-control bg-danger">
                                            <i className="fa fa-remove"></i> Belum Terdaftar  
                                        </div>
                                    </div> : null
                        }                        
                    </div>                                    
                </div>               
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    city_id         : state.authReducer.city_id,
    cekKartuState   : state.formCekKartu
})

const mapDispatchToProps = (dispatch) => ({
    updateItemsState: items => {
        dispatch(updateCekKartuState(items))
    },
    resetCekKartuState: () => {
        dispatch(resetCekKartuState())
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(FormCekKartu);


// WEBPACK FOOTER //
// ./src/components/FormCekKartu.js